// extracted by mini-css-extract-plugin
module.exports = {"alarm_close":"modal_alarm_close__2Wu5e","alarm_modal":"modal_alarm_modal__2vU33","alarm_modal_lg":"modal_alarm_modal_lg__3DM9A","alarm_modal_bg":"modal_alarm_modal_bg__Mi1uR"};